import { Model } from 'json-api-models';

import { Models, Schemas } from '../models.ts';

export class TutorialRevision extends Model<Schemas['tutorialRevisions'], Models> {}
